import { WITH_KIDS_PARENTS_PRICE, WITH_PARTNER_PRICE, SINGLE_ONLY_PRICE, } from './models';
export var calculateLiabilityPricing = function (inclusiveMembers) {
    if (inclusiveMembers.includes('KIDS') ||
        inclusiveMembers.includes('PARENTS')) {
        return WITH_KIDS_PARENTS_PRICE;
    }
    if (inclusiveMembers.includes('PARTNER')) {
        return WITH_PARTNER_PRICE;
    }
    return SINGLE_ONLY_PRICE;
};
